import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsermin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.738 10.44a5.113 5.113 0 0 0-1.102-1.634 5.135 5.135 0 0 0-1.634-1.102l-.017-.007a3.39 3.39 0 1 0-3.97.001L5 7.706a5.091 5.091 0 0 0-1.634 1.102A5.136 5.136 0 0 0 1.86 12.33a.11.11 0 0 0 .109.112h.82a.11.11 0 0 0 .11-.106 4.076 4.076 0 0 1 1.2-2.793A4.074 4.074 0 0 1 7 8.34a4.07 4.07 0 0 1 2.901 1.202 4.076 4.076 0 0 1 1.2 2.793c.002.06.05.106.11.106h.82a.109.109 0 0 0 .102-.069.11.11 0 0 0 .008-.043 5.096 5.096 0 0 0-.403-1.89ZM7 7.3a2.336 2.336 0 0 1-1.662-.688 2.336 2.336 0 0 1-.69-1.663c0-.627.245-1.218.69-1.662A2.336 2.336 0 0 1 7 2.597c.628 0 1.218.245 1.663.69.444.444.689 1.035.689 1.662 0 .628-.245 1.218-.69 1.663A2.336 2.336 0 0 1 7 7.3Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgUsermin);
export { ForwardRef as ReactComponent };
